$(document).ready(function () {
    var ReferenceNumberRequest = function (vm) {
        var self = this;

        self.CarrierName = vm.carrierName();
        self.ContactName = vm.contactName();
        self.ContactPhone = vm.contactPhoneNumber();
        self.ContactEmail = vm.contactEmailAddress();
        self.ShipperName = vm.shipperName();
        self.Base64BillOfLading = vm.fileData().base64String();
        self.FileType = vm.fileData().file().type;
        self.FileName = vm.fileData().file().name;
    };

    var RequestReferenceNumberViewModel = function () {
        var self = this;

        self.carrierName = ko.observable("");
        self.contactName = ko.observable("");
        self.contactPhoneNumber = ko.observable("");
        self.contactEmailAddress = ko.observable("");
        self.shipperName = ko.observable("");
        self.fileData = ko.observable({
            file: ko.observable(),
            dataURL: ko.observable(),
            text: ko.observableArray(),
            arrayBuffer: ko.observableArray(),
            base64String: ko.observableArray(),
        });

        self.resetForm = function() {
            self.carrierName("");
            self.contactName("");
            self.contactPhoneNumber("");
            self.contactEmailAddress("");
            self.shipperName("");
            self.fileData().clear();
        };

        self.IsValidForm = function () {
            var pRE = /\+?\d?[-\s]*\(?\d\d\d\)?[-\s]*\d\d\d[-\s]*\d\d\d\d/;
            var phoneMatch = self.contactPhoneNumber().match(pRE);
            var eRE = /.*@.+\..+/i;
            var eMatch = self.contactEmailAddress().match(eRE);
            var file = self.fileData().file();
            var validFileTypes = ["pdf", "jpg", "jpeg", "png", "bmp"];
            var hasFileType = file && file.type.match(/\/(.*)/);
            var fileType = hasFileType && hasFileType[1];

            if (self.carrierName() === '') {
                $.growl({ title: "", message: "Please Enter Carrier name.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (self.contactName() === '') {
                $.growl({ title: "", message: "Please Enter Your Name.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (!phoneMatch) {
                $.growl({ title: "", message: "Please Enter Your Phone Number.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (!eMatch) {
                $.growl({ title: "", message: "Please Enter Your Email Address.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (self.shipperName() === '') {
                $.growl({ title: "", message: "Please Enter The Shipper Name from the BOL.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (!file || file && file.name === '') {
                $.growl({ title: "", message: "Please upload a valid Bill Of Lading.", style: "error", size: "large", location: "tr" });
                return false;
            }
            if (validFileTypes.indexOf(fileType) === -1) {
                var message = "Please upload a Bill of Lading with one of the following file types: " + validFileTypes.join(", ");
                $.growl({ title: "Invalid File Type", message: message, style: "error", size: "large", location: "tr" });
                return false;
            }
            if (file && file.size === 0) {
                $.growl({ title: "", message: "Please upload a non-empty Bill Of Lading.", style: "error", size: "large", location: "tr" });
                return false;
            }

            return true;
        };

        self.submitRequest = function () {
            if (!self.IsValidForm()) {
                return;
            }
            var request = new ReferenceNumberRequest(self);

            $.ajax({
                type: 'POST',
                url: '/RequestReferenceNumber/SubmitReferenceNumberRequest',
                contentType: 'application/json',
                data: JSON.stringify(request),
                success: function (success) {
                    if (success) {
                        $.growl.notice({ title: "", message: "Your Request has been submitted. You will receive an email from a team member soon.", size: "large", location: "tr" });
                        self.resetForm();
                    } else {
                      $.growl.error({ title: "", message: "Request failed. Please check information and resubmit your Request.", size: "large", location: "tr" });
                    }
                },
                error: function (error) {
                    $.growl.error({ title: "", message: "Request failed. Please try to resubmit your Request.", size: "large", location: "tr" });
                    console.log("Call Failed");
                }
            });
        };

    };

    var requestReferenceNumberViewModel = new RequestReferenceNumberViewModel();
    ko.applyBindings(requestReferenceNumberViewModel);
});